export enum SessionStorageKeysEnum {
  order = 'order',
  step = 'step',
  new_user = 'new_user',
}
